import { render, staticRenderFns } from "./AppPagination.vue?vue&type=template&id=23b881a7"
import script from "./AppPagination.vue?vue&type=script&lang=ts"
export * from "./AppPagination.vue?vue&type=script&lang=ts"
import style0 from "./AppPagination.vue?vue&type=style&index=0&id=23b881a7&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports